export const withLineBreaks = (text: string, maxLength = 40): string => {
  const tokens = text.split(" ");
  const parts: string[] = [];

  let lineLength = 0;
  tokens.forEach((token, i) => {
    if (lineLength > maxLength) {
      parts.push(`\n${token}`);
      lineLength = token.length;
      return;
    }

    if (i === 0) {
      parts.push(token);
      lineLength += token.length;
      return;
    }

    parts.push(` ${token}`);
    lineLength += token.length + 1;
  });

  return parts.join("");
};
